import { Fragment, useState } from 'react';
import { Box, Fade, Grid2 } from '@mui/material';
import { useExperiences } from 'core/contexts/experienceV2';
import { PaginationControlled } from '@utriper/core-ui';
import ExperienceCard from '../ExperienceCard';
import UpdateStatusForm from 'modules/Experience/components/UpdateStatusForm';

const ExperienceCards = () => {
    const { loading, experiences, totalExperiences, MAX_PAGE, expPage, handlePage } = useExperiences();
    const [open, setOpen] = useState(false);
    const [experienceId, setExperienceId] = useState(null);
    const [status, setStatus] = useState(null);

    const handleStatus = (expId, newStatus) => {
        setOpen(true);
        setExperienceId(expId);
        setStatus(newStatus);
    };

    return (
        <Fragment>
            <Fade in={!loading} timeout={300}>
                <Box component="section" display="flex" flexDirection="column" mt="24px" gap="24px">
                    <Grid2 container size={12} spacing={2}>
                        {experiences.map(({ id, name, status, location, price, priceGroupId, currency, duration, pictureURL }) => (
                            <ExperienceCard key={id} id={id} name={name} status={status} location={location} price={price} priceGroupId={priceGroupId} currency={currency} duration={duration} pictureURL={pictureURL} handleStatus={handleStatus} />
                        ))}
                    </Grid2>
                    {totalExperiences / MAX_PAGE > 1 && <PaginationControlled count={Math.ceil(totalExperiences / MAX_PAGE)} page={expPage} onChange={handlePage} totalItems={totalExperiences} itemsPerPage={MAX_PAGE} />}
                </Box>
            </Fade>

            {open && (
                <UpdateStatusForm
                    open={open}
                    handleClose={() => {
                        setOpen(false);
                        setExperienceId(null);
                        setStatus(null);
                    }}
                    status={status}
                    experienceId={experienceId}
                    experienceIds={[]}
                />
            )}
        </Fragment>
    );
};

export default ExperienceCards;
